import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/command/command-group.component.js'

const tagName = 'dap-ds-command-group'

/**
 * `dap-ds-command-group`
 * @summary A command group is a group of command items.
 * @element dap-ds-command-group
 * @title - Command group
 * @group command
 *
 * @slot - The default slot for the command group.
 *
 * @csspart base - The base part of the command group.
 * @csspart label - The label part of the command group.
 * @csspart items - The items part of the command group.
 *
 * @cssproperty --dds-command-group-gap - The gap between command group elements. (default: var(--dds-spacing-100))
 * @cssproperty --dds-command-group-margin-bottom - The bottom margin of the command group. (default: var(--dds-spacing-200))
 * @cssproperty --dds-command-group-border-radius - The border radius of the command group. (default: var(--dds-radius-small))
 * @cssproperty --dds-command-group-label-font-weight - The font weight of the command group label. (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-command-group-items-gap - The gap between command items. (default: var(--dds-spacing-100))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCommandGroup',
})

export default reactWrapper
